/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Spinner } from "react-bootstrap";
import { Trash, PencilSimpleLine, Plus, MagnifyingGlass } from "@phosphor-icons/react";
import api from "../../utils/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Topic = () => {
  // State variables
  const [fetchedData, setFetchedData] = useState([]);
  const [show, setShow] = useState(false);
  const [topicName, setTopicName] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");
  const [ID, setID] = useState(null);
  const isEditMode = Boolean(ID);

  const [modules, setModules] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [filterModule, setFilterModule] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Add Topic");
  const [userPermissions, setUserPermissions] = useState({});

  useEffect(() => {
    auth();
    fetchModules();
    fetchData();
  }, []);

  async function auth() {
    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getPagePermission";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);
      fd.append("limit", itemsPerPage);
      fd.append("pageNo", 5);

      const response = await api.post("user/userCurl", fd);
      if (response.data && response.data.data.length > 0) {
        setUserPermissions(response.data.data[0]);
      }
    } catch (error) {
      setUserPermissions({});
      toast.error("Error fetching permissions.");
    } finally {
      setLoading(false);
    }
  }

  async function fetchModules() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getAllDetails");

      const response = await api.post("module/moduleCurl", fd);
      if (Array.isArray(response.data.getResponse)) {
        setModules(response.data.getResponse);
      } else {
        setModules([]);
      }
    } catch (error) {
      setModules([]);
    }
  }

  async function fetchSubjects(moduleId) {
    if (!moduleId) {
      setSubjects([]);
      return [];
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const role = localStorage.getItem("role");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getSubjectByModule");
      fd.append("role", role);
      fd.append("module", moduleId);

      const res = await api.post("subject/subjectCurl", fd);

      console.log("sub", res)

      if (Array.isArray(res.data.data)) {
        setSubjects(res.data.data);
        return res.data.data;
      }

      setSubjects([]);
      return [];
    } catch {
      setSubjects([]);
      return [];
    }
  }
async function fetchSubjectsWhileEditing() {
  try {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role");

    const fd = new FormData();
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("programType", "getAllDetails");
    fd.append("role", role);
    fd.append("limit", 1000);

    const res = await api.post("subject/subjectCurl", fd);

    if (Array.isArray(res.data.getSubjectDetails)) {
      setSubjects(res.data.getSubjectDetails);
      return res.data.getSubjectDetails;
    }

    setSubjects([]);
    return [];
  } catch {
    setSubjects([]);
    return [];
  }
}

 


  async function fetchChapters(subjectId) {
    if (!subjectId) {
      setChapters([]);
      return [];
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getChapterOnChange");
      fd.append("subjectId", subjectId);

      const res = await api.post("onchange/onchangeCurl", fd);
      console.log("chap", res)  

      if (Array.isArray(res.data.data)) {
        setChapters(res.data.data);
        return res.data.data;
      }

      setChapters([]);
      return [];
    } catch {
      setChapters([]);
      return [];
    }
  }


  async function fetchData(page = 1, moduleId = filterModule, search = "") {
    setDataLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getTopicsDetails");
      fd.append("page", page);
      fd.append("limit", itemsPerPage);

      if (moduleId) {
        fd.append("moduleId", moduleId);
      }

      if (search.trim() !== "") {
        fd.append("searchTerm", search.trim());
      }

      const response = await api.post("topic/topicCurl", fd);

      if (response.data && Array.isArray(response.data.getTopicsDetails)) {
        setFetchedData(response.data.getTopicsDetails);
        setCurrentPage(page);
        setTotalItems(response.data.totalPages * itemsPerPage);
      } else {
        setFetchedData([]);
        setTotalItems(0);
      }
    } catch {
      setFetchedData([]);
      setTotalItems(0);
    } finally {
      setDataLoading(false);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);



    if (!selectedSubject) {
      toast.error("Please select Subject");
      setLoading(false);
      return;
    }

    if (!selectedChapter) {
      toast.error("Please select Chapter");
      setLoading(false);
      return;
    }

    if (!topicName.trim()) {
      toast.error("Please enter topic name");
      setLoading(false);
      return;
    }

    setButtonText(ID ? "Updating..." : "Adding...");

    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = ID ? "updateTopic" : "addTopic";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("subject", selectedSubject);
    fd.append("chapter", selectedChapter);
    fd.append("topic", topicName.trim());

    if (ID) {
      fd.append("id", ID);
    }

    try {
      const response = await api.post("topic/topicCurl", fd);

      if (response.data.status === true) {
        toast.success(response.data.data || "Operation successful");
        fetchData(currentPage, filterModule, searchTerm);
        handleClose();
      } else {
        toast.error(response.data.data || "Operation failed");
      }
    } catch (error) {
      toast.error("There was an error submitting the form. Please try again.");
    } finally {
      setLoading(false);
      setButtonText("Add Topic");
    }
  }

  const handleShowAdd = () => {
    setShow(true);
    setID(null);
    setTopicName("");
    setButtonText("Add Topic");
    setSelectedModule("");
    setSelectedSubject("");
    setSelectedChapter("");
  };

async function handleShowEdit(topic) {
  setButtonText("Update Topic");

  const loggedInUser = localStorage.getItem("loggedInUser");
  const token = localStorage.getItem("authToken");

  const fd = new FormData();
  fd.append("programType", "getDetailsForUpdate");
  fd.append("loggedInUser", loggedInUser);
  fd.append("token", token);
  fd.append("id", topic.id);

  try {
    const response = await api.post("topic/topicCurl", fd);

    if (response.data?.getTopicsDetails?.length) {
      const d = response.data.getTopicsDetails[0];

      setID(d.id);
      setTopicName(d.topicName);

      // 🚫 NO class/module logic in edit (same as Chapter)
      setSelectedModule("");

      // ✅ load ALL subjects first
      const allSubjects = await fetchSubjectsWhileEditing();

      // ✅ set subject AFTER subjects exist
      if (allSubjects.length) {
        setSelectedSubject(String(d.subjectId));

        // ✅ now load chapters for that subject
        const chapterList = await fetchChapters(d.subjectId);
        if (chapterList.length) {
          setSelectedChapter(String(d.chapterId));
        }
      }

      setShow(true);
    }
  } catch {
    toast.error("Error fetching topic details");
  }
}



  const handleClose = () => {
    setShow(false);
    setTopicName("");
    setSelectedModule("");
    setSelectedSubject("");
    setSelectedChapter("");
    setID(null);
  };

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this topic?")) return;

    setLoading(true);
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "deleteTopic";

      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("id", id);

      const response = await api.post("topic/topicCurl", fd);
      toast.success("Topic deleted successfully");
      fetchData(currentPage, filterModule, searchTerm);
    } catch (error) {
      toast.error("Error deleting topic.");
    } finally {
      setLoading(false);
    }
  }

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchData(page, filterModule, searchTerm);
    }
  };

  const createPagination = () => {
    const pageNumbers = [];
    const range = 2;
    const maxPageNumber = totalPages;

    pageNumbers.push(1);
    if (currentPage > range + 2) {
      pageNumbers.push("...");
    }
    for (
      let i = Math.max(currentPage - range, 2);
      i <= Math.min(currentPage + range, maxPageNumber - 1);
      i++
    ) {
      pageNumbers.push(i);
    }
    if (currentPage < maxPageNumber - range - 1) {
      pageNumbers.push("...");
    }
    if (maxPageNumber > 1) {
      pageNumbers.push(maxPageNumber);
    }

    return pageNumbers;
  };

  const TableLoader = ({ rows = 10, columns = 5 }) => (
    <tbody>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} style={{ textAlign: "center", padding: "16px" }}>
              <div
                style={{
                  height: "20px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s infinite"
                }}
              ></div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
    }}>
      {userPermissions.is_view === "0" ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <h4 style={{ color: "#dc2626" }}>Permission Denied</h4>
        </div>
      ) : (
        <>
          {/* Header Section */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              flexWrap: "wrap",
              gap: "16px"
            }}>
              <div>
                <h1 style={{
                  fontSize: "28px",
                  fontWeight: "700",
                  color: "#1e293b",
                  margin: 0
                }}>
                  Topics
                </h1>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "14px",
                  color: "#64748b",
                  marginTop: "4px"
                }}>
                  <span>Manage all topics in the system</span>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                {/* Search Bar */}
                <div style={{ position: "relative" }}>
                  <div style={{
                    position: "absolute",
                    left: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    zIndex: 1
                  }}>
                    <MagnifyingGlass size={20} />
                  </div>
                  <input
                    type="text"
                    placeholder="Search topics..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      padding: "12px 20px 12px 48px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "280px",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                    }}
                    onKeyDown={(e) => e.key === "Enter" && fetchData(1, filterModule, searchTerm)}
                  />
                </div>

                {/* Filter by Class */}
                <div style={{ minWidth: "180px" }}>
                  <select
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      fontSize: "14px",
                      width: "100%",
                      outline: "none",
                      transition: "all 0.2s",
                      background: "#fff",
                      color: "#334155",
                      cursor: "pointer"
                    }}
                    value={filterModule}
                    onChange={(e) => {
                      const moduleId = e.target.value;
                      setFilterModule(moduleId);
                      setCurrentPage(1);
                      fetchData(1, moduleId, searchTerm);
                    }}
                  >
                    <option value="">All Classes</option>
                    {modules.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.moduleName}
                      </option>
                    ))}
                  </select>
                </div>

                {userPermissions.is_add === "1" && (
                  <button
                    onClick={handleShowAdd}
                    style={{
                      background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
                      color: "#fff",
                      border: "none",
                      padding: "12px 24px",
                      borderRadius: "12px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.3s",
                      boxShadow: "0 2px 8px rgba(62, 128, 249, 0.3)"
                    }}
                    onMouseEnter={(e) => e.target.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.target.style.transform = "translateY(0)"}
                  >
                    <Plus size={20} weight="bold" />
                    Add New Topic
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Topics Table */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            marginTop: "16px"
          }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: "800px",
                fontSize: "13px"
              }}>
                <thead
                  style={{
                    background: "#f8fafc",
                    borderBottom: "2px solid #e5e7eb"
                  }}
                >
                  <tr>
                    <th
                      style={{
                        width: "48px",
                        minWidth: "48px",
                        maxWidth: "48px",
                        padding: "14px 8px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      #
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Topic Name
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Subject
                    </th>
                    <th
                      style={{
                        padding: "14px 16px",
                        textAlign: "left",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.4px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Chapter
                    </th>
                   
                    {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                      <th
                        style={{
                          padding: "14px 16px",
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: "700",
                          color: "#475569",
                          textTransform: "uppercase",
                          letterSpacing: "0.4px",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Actions
                      </th>
                    )}
                  </tr>
                </thead>

                {dataLoading ? (
                  <TableLoader rows={6} columns={userPermissions.is_edit === "1" || userPermissions.is_delete === "1" ? 6 : 5} />
                ) : (
                  <tbody>
                    {fetchedData.length === 0 ? (
                      <tr>
                        <td colSpan={userPermissions.is_edit === "1" || userPermissions.is_delete === "1" ? 6 : 5} style={{ padding: "40px", textAlign: "center" }}>
                          <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "12px",
                            color: "#94a3b8"
                          }}>
                            <div style={{
                              fontSize: "36px",
                              background: "#f1f5f9",
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                              📝
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: "600", color: "#475569" }}>
                              No topics found
                            </div>
                            <div style={{ fontSize: "13px", maxWidth: "300px" }}>
                              {searchTerm || filterModule
                                ? "Try adjusting your filters or search"
                                : "Create your first topic"}
                            </div>
                            {!searchTerm && !filterModule && userPermissions.is_add === "1" && (
                              <button
                                onClick={handleShowAdd}
                                style={{
                                  background: "#3E80F9",
                                  color: "#fff",
                                  border: "none",
                                  padding: "8px 20px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  cursor: "pointer",
                                  marginTop: "8px"
                                }}
                              >
                                Create First Topic
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ) : (
                      fetchedData.map((topic, index) => (
                        <tr key={topic.id} style={{
                          borderBottom: "1px solid #f1f5f9",
                          transition: "background 0.2s"
                        }}>
                          <td
                            style={{
                              width: "48px",
                              minWidth: "48px",
                              maxWidth: "48px",
                              padding: "6px",
                              fontSize: "12px",
                              color: "#64748b",
                              fontWeight: "500",
                              textAlign: "center",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "6px",
                                background: "#f1f5f9",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "600",
                                fontSize: "12px",
                                color: "#475569",
                                margin: "0 auto"
                              }}
                            >
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1e293b",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap"
                            }}>
                              {topic.topicName}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#64748b"
                            }}>
                              {topic.subjectName}
                            </div>
                          </td>

                          <td style={{ padding: "12px" }}>
                            <div style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#64748b"
                            }}>
                              {topic.chapterName}
                            </div>
                          </td>

                         
                          {(userPermissions.is_edit === "1" || userPermissions.is_delete === "1") && (
                            <td style={{ padding: "12px", textAlign: "center" }}>
                              <div style={{
                                display: "flex",
                                gap: "6px",
                                justifyContent: "center",
                                flexWrap: "wrap"
                              }}>
                                {userPermissions.is_edit === "1" && (
                                  <button
                                    onClick={() => handleShowEdit(topic)}
                                    title="Edit Topic"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#eff6ff",
                                      color: "#3b82f6",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#dbeafe"}
                                    onMouseLeave={(e) => e.target.style.background = "#eff6ff"}
                                  >
                                    <PencilSimpleLine size={14} />
                                  </button>
                                )}

                                {userPermissions.is_delete === "1" && (
                                  <button
                                    onClick={() => handleDelete(topic.id)}
                                    title="Delete Topic"
                                    style={{
                                      width: "32px",
                                      height: "32px",
                                      borderRadius: "8px",
                                      border: "none",
                                      background: "#fef2f2",
                                      color: "#dc2626",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      transition: "all 0.2s",
                                      flexShrink: 0
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = "#fee2e2"}
                                    onMouseLeave={(e) => e.target.style.background = "#fef2f2"}
                                  >
                                    <Trash size={14} />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {/* Compact Pagination */}
            {!dataLoading && fetchedData.length > 0 && (
              <div style={{
                padding: "16px 20px",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px",
                fontSize: "13px"
              }}>
                <div style={{ color: "#64748b" }}>
                  Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                </div>
                <div style={{ display: "flex", gap: "4px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === 1 ? "#f1f5f9" : "#fff",
                      color: currentPage === 1 ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    ← Prev
                  </button>

                  <div style={{ display: "flex", gap: "2px" }}>
                    {createPagination().map((page, index) => (
                      <button
                        key={index}
                        onClick={() => typeof page === "number" && handlePageChange(page)}
                        style={{
                          padding: "6px 10px",
                          background: currentPage === page ? "#3E80F9" : "#fff",
                          color: currentPage === page ? "#fff" : "#334155",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          cursor: typeof page === "number" ? "pointer" : "default",
                          fontSize: "12px",
                          minWidth: "32px",
                          transition: "all 0.2s",
                          fontWeight: currentPage === page ? "600" : "500"
                        }}
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 12px",
                      background: currentPage === totalPages ? "#f1f5f9" : "#fff",
                      color: currentPage === totalPages ? "#94a3b8" : "#334155",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "12px",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    Next →
                  </button>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />

      {/* Modal for adding/editing topic */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "14px 24px",
          background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
          color: "#fff"
        }}>
          <div>
            <Modal.Title style={{ fontSize: "20px", fontWeight: "700", marginBottom: "4px", color: "#fff" }}>
              {ID ? "✏️ Edit Topic" : "➕ Add Topic"}
            </Modal.Title>
            <div style={{ fontSize: "13px", opacity: 0.9 }}>
              {ID ? "Update topic details" : "Create a new topic"}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={{
          padding: "28px",
          background: "#f8fafc"
        }}>
          <form onSubmit={handleSubmit} id="add-topic-form">
            {/* Select Class */}
            {!isEditMode && (

            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Select Class <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "all 0.2s",
                  background: "#fff",
                  color: "#334155",
                  cursor: "pointer"
                }}
                value={selectedModule}
                onChange={(e) => {
                  const moduleId = e.target.value;
                  setSelectedModule(moduleId);
                  setSelectedSubject("");
                  setSelectedChapter("");
                  setSubjects([]);
                  setChapters([]);
                  if (moduleId) {
                    fetchSubjects(moduleId);
                  }
                }}
                required
              >
                <option value="">Select Class</option>
                {modules.map((mod) => (
                  <option key={mod.id} value={mod.id}>
                    {mod.moduleName}
                  </option>
                ))}
              </select>
            </div>
            )}

            {/* Select Subject */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Select Subject <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "all 0.2s",
                  background: "#fff",
                  color: "#334155",
                  cursor: "pointer"
                }}
                value={selectedSubject}
                onChange={(e) => {
                  const subjectId = e.target.value;
                  setSelectedSubject(subjectId);
                  setSelectedChapter("");
                  setChapters([]);
                  if (subjectId) {
                    fetchChapters(subjectId);
                  }
                }}
                required
              
              >
                <option value="">Select Subject</option>
                {subjects.map((subject) => (
                  <option key={subject.id} value={String(subject.id)}>
                    {subject.subjectName}
                  </option>

                ))}
              </select>
            </div>

            {/* Select Chapter */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Select Chapter <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "all 0.2s",
                  background: "#fff",
                  color: "#334155",
                  cursor: "pointer"
                }}
                value={selectedChapter}
                onChange={(e) => setSelectedChapter(e.target.value)}
                required
                disabled={!selectedSubject}
              >
                <option value="">Select Chapter</option>
                {chapters.map((chapter) => (
                  <option key={chapter.id} value={String(chapter.id)}>
                    {chapter.chapterName}
                  </option>

                ))}
              </select>
            </div>

            {/* Topic Name */}
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#334155"
              }}>
                Topic Name <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  fontSize: "14px",
                  outline: "none",
                  transition: "all 0.2s",
                  background: "#fff",
                  color: "#334155"
                }}
                placeholder="Enter topic name"
                id="topicName"
                name="topicName"
                value={topicName}
                onChange={(e) => setTopicName(e.target.value)}
                required
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer style={{
          borderTop: "1px solid #e5e7eb",
          padding: "24px 28px",
          background: "#f8fafc"
        }}>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              background: "#f1f5f9",
              color: "#475569",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s"
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: "linear-gradient(135deg, #3E80F9 0%, #2d5bff 100%)",
              color: "#fff",
              border: "none",
              padding: "10px 24px",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              transition: "all 0.2s",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {buttonText}
              </>
            ) : (
              buttonText
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          *:focus {
            outline: 2px solid #3E80F9;
            outline-offset: 2px;
          }
          
          button:hover:not(:disabled) {
            transform: translateY(-2px);
          }
          
          .modal-content {
            border-radius: 20px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          }
          
          select:hover, input:hover {
            border-color: #94a3b8 !important;
          }
          
          select:focus, input:focus {
            border-color: #3E80F9 !important;
            box-shadow: 0 0 0 3px rgba(62, 128, 249, 0.1) !important;
          }
        `}
      </style>
    </div>
  );
};

export default Topic;